import React, { useState } from 'react';
import { auth } from './firebase';
import './SignIn.css';
import logo from './ayla-logo.png';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSignIn = (e) => {
    e.preventDefault();
    auth.signInWithEmailAndPassword(email, password)
      .catch((error) => {
        setMessage(error.message);
      });
  };

  const handlePasswordReset = () => {
    if (!email) {
      setMessage('Please enter your email address to reset your password.');
      return;
    }
    auth.sendPasswordResetEmail(email)
      .then(() => {
        setMessage('Password reset email sent. Please check your inbox.');
      })
      .catch((error) => {
        setMessage(error.message);
      });
  };

  return (
    <div className="sign-in-container">
      <div className="sign-in-form">
        <img src={logo} alt="AYLA" className="logo" />
        <h1>Sign in to your vendor account</h1>
        {message && <p className="error-message">{message}</p>}
        <form onSubmit={handleSignIn}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="form-buttons">
            <button type="button" className="cancel-btn">CANCEL</button>
            <button type="submit" className="save-btn">SIGN IN</button>
          </div>
        </form>
        <p>Don't have an account? <a href="/signup">Sign up</a></p>
        <p><a href="#" onClick={handlePasswordReset}>Forgot Password?</a></p>
      </div>
    </div>
  );
};

export default SignIn;
